/**
 * Superuser / full admin access:
 * - `ananunaki: true` on the user document (and tolerant forms from JSON)
 * - OR `allPermissions` from login/verify includes `*` (see API getEffectivePermissionKeys for ananunaki users)
 *
 * The `*` fallback fixes cases where session state lost `ananunaki` but still has the computed permission list.
 */
export function isAnanunakiSuperuser(user) {
	if (!user) return false;
	if (Array.isArray(user.allPermissions) && user.allPermissions.includes("*")) return true;
	if (user.ananunaki == null) return false;
	const v = user.ananunaki;
	if (v === true || v === 1) return true;
	if (typeof v === "string" && v.toLowerCase() === "true") return true;
	return false;
}

/** When replacing `user` from an API response, keep login-only fields so RBAC/superuser checks keep working. */
export function mergeUserSessionFields(prev, next) {
	if (!next || typeof next !== "object") return next;
	const merged = { ...next };
	if (prev && typeof prev === "object") {
		if (merged.allPermissions === undefined && prev.allPermissions !== undefined) {
			merged.allPermissions = prev.allPermissions;
		}
		if (merged.ananunaki === undefined && prev.ananunaki !== undefined) {
			merged.ananunaki = prev.ananunaki;
		}
		if (merged.permissionOverrides === undefined && prev.permissionOverrides !== undefined) {
			merged.permissionOverrides = prev.permissionOverrides;
		}
		if (merged.permissions === undefined && prev.permissions !== undefined) {
			merged.permissions = prev.permissions;
		}
	}
	return merged;
}

/** Same as isAnanunakiSuperuser (alias for config / sidebar imports). */
export const isUserAnanunaki = isAnanunakiSuperuser;
